<template>
  <Dialog
    v-model:visible="modal"
    :closable
    :pt="{
      mask: {
        class: '!bg-modal-opacity',
      },
      header: {
        class: '*:text-[1.875rem] *:!text-black mb-2 flex gap-2 items-center',
      },
    }"
    modal
    :style="{ width: '90vw', maxWidth: '890px' }"
    @hide="emit('hide')"
  >
    <template #header>
      <slot name="title">
        <h2>
          {{ title }}
        </h2>
      </slot>
    </template>
    <div v-if="description" class="text-base text-black mb-6" v-html="description" />

    <slot />
  </Dialog>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    description?: string
    small?: boolean
    contentClass?: string
    closable?: boolean
  }>(),
  {
    small: false,
    title: undefined,
    description: undefined,
    contentClass: '',
    closable: true,
  }
)

const modal = defineModel({ type: Boolean })

const emit = defineEmits<{
  (e: 'hide'): void
}>()
</script>

<style scoped></style>
